export interface GenericMapSearchResult {
  customerId: number;
  paSystem: string;
  agreementId: number | null;
  agreementType: string;
  agreementAddress: string;
  agreementEstate: string;
  agreementLatitude: number | null;
  agreementLongitude: number | null;
  agreementLineId: number | null;
  agreementLineLatitude: number | null;
  agreementLineLongitude: number | null;
  placeNumber: number | null;
  placeLongitude: number | null;
  placeLatitude: number | null;
  routeLineLatitude: number | null;
  routeLineLongitude: number | null;
  routeLineId: number | null;
  route: string;
  placeName: string;
  placeType: string;
  unitId: string;
  unitName: string;
  fractionName: string;
  fractionId: string;
  routeName?: string;
}

export interface GenericMapAgreement {
  paSystem: string;
  agreementId: number;
  agreementType: string;
  agreementAddress: string;
  agreementEstate: string;
  agreementLatitude: number;
  agreementLongitude: number;
  routeIds: string[];
  routeNames: string[];
}

export interface GenericMapPlace {
  paSystem: string;
  placeNumber: number;
  placeLatitude: number;
  placeLongitude: number;
  placeName: string;
  placeType: string;
  agreementId: number;
  routeIds: string[];
}
export interface GenericMapRoute {
  paSystem: string;
  route: string;
}

export interface GenericMapAgreementLine {
  paSystem: string;
  agreementId: number | null;
  agreementLineId: number | null;
  agreementLineLatitude: number | null;
  agreementLineLongitude: number | null;
  placeNumber: number | null;
  routeLineId: number | null;
  route: string;
  unitId: string;
  unitName: string;
  fractionName: string;
  fractionId: string;
  routeIds: string[];
  agreementAddress: string;
  routeNames?: string[];
}

export interface GenericMapRouteLine {
  routeLineId: number;
  routeLineLatitude: number;
  routeLineLongitude: number;
  agreementId: number;
  agreementLineId: number;
  placeNumber: number;
  route: string;
  paSystem: string;
  routeIds: string[];
}

export interface IGroupedGenericMapData {
  genericMapRoutes: GenericMapRoute[];
  genericMapAgreements: GenericMapAgreement[];
  genericMapPlaces: GenericMapPlace[];
  genericMapAgreementLines: GenericMapAgreementLine[];
  genericMapRouteLines: GenericMapRouteLine[];
}

export enum SmartMapGridTypes {
  AGREEMENTS_GRID = 'AGREEMENT_GRID',
  PLACES_GRID = 'PLACES_GRID',
  BINS_GRID = 'BINS_GRID',
}

export interface DisplayedGenericMapElement {
  lat: number;
  lng: number;
  elements:
    | GenericMapAgreement[]
    | GenericMapAgreementLine[]
    | GenericMapPlace[]
    | GenericMapRouteLine[];
  routeIds: string[];
}

export enum SmartMapElementType {
  AGREEMENTS = 'AGREEMENTS',
  BINS = 'BINS',
}

export interface HighlightedMarkers {
  category: string;
  value: string;
}

export interface GeoJsonObject {
  type: string;
  features: any[];
}

export enum ISmartMapFilterType {
  FORM = 'FORM',
  ROUTE = 'ROUTE',
  EXTENT = 'EXTENT',
}
